'use client';

import { useAtomValue, useSetAtom } from 'jotai';

import { openFinanceLeadModalAtom } from '@core/Atoms/FinanceModal/FinanceModal.atom';
import { formStateAtom } from '@core/Atoms/Pdp/FormState.atom';
import { searchParamsAtom } from '@core/Atoms/SearchParams/SearchParams.atom';
import { userIdAtom } from '@core/Atoms/User/UserId.atom';
import { currentVehicleAtom } from '@core/Atoms/Vehicle/CurrentVehicle.atom';
import { currentVehicleIdAtom } from '@core/Atoms/Vehicle/CurrentVehicleId.atom';
import Button from '@gds/Button/Button';
import { Error as ErrorIcon } from '@gds/Icons/Paths/Error';
import { Typography } from '@gds/Typography/Typography';
import { trackCustomEvent } from '@tracking/Utils/TrackCustomEvent';

import { generateLeadTrackingData } from '../../../Tracking/FincalcLead.tracking';
import type { CalculatorMessages } from '../Calculator.messages';

import styles from '../Calculator.module.css';

type Props = {
  strings: CalculatorMessages;
};

export const LoadingCalculatorOverlay = ({ strings }: Props) => {
  const triggerOpenModal = useSetAtom(openFinanceLeadModalAtom);
  const vehicle = useAtomValue(currentVehicleAtom)!;
  const listingId = useAtomValue(currentVehicleIdAtom);
  const searchParams = useAtomValue(searchParamsAtom);
  const formState = useAtomValue(formStateAtom);
  const userId = useAtomValue(userIdAtom);
  triggerOpenModal(false);
  const handleButtonClick = () => {
    const {
      leadStart: { event, context },
    } = generateLeadTrackingData({
      searchParams,
      userId,
      formState,
      leadFormId: 'message-dealer',
      listingId,
      vehicle,
    });
    trackCustomEvent({ event, context });
    triggerOpenModal(true);
  };
  return (
    <>
      <div className={styles.errorLabel}>
        <p>
          <ErrorIcon />
        </p>
        <Typography variant="h3">{strings.errorOverlayTitle}</Typography>

        <Typography Component="p" variant="h5">
          {strings.errorOverlayBody}
        </Typography>
      </div>
      <div>
        <Button onClick={handleButtonClick} variant="contained">
          {strings.errorMessageDealer}
        </Button>
      </div>
    </>
  );
};
